document.addEventListener('DOMContentLoaded', () => {
  const featuredCards = document.querySelectorAll('.card--featured');

  const updateCardHeights = () => {
    featuredCards.forEach((el) => {
      const cardHeader = el.querySelector('.card__header');
      const headerHeight = cardHeader?.offsetHeight || 0;
      el.style.setProperty('--header-height', `-${headerHeight}px`);
    });
  };

  updateCardHeights();
  window.addEventListener('resize', () => {
    updateCardHeights();
  });
});
